export const editableStructureTypes = ['Site', 'Building', 'Block', 'Core', 'Entrance', 'Floor', 'Common area', 'Land'];
/** References distinguish repeated flat labels. Guard historic malformed trees too. */
export function structurePath(nodes, id, byId = new Map(nodes.map(node => [node.id, node]))) {
    const parts = [], seen = new Set();
    while (id && !seen.has(id)) {
        seen.add(id);
        const node = byId.get(id);
        if (!node)
            break;
        parts.unshift(`${node.name} [${node.premisesCode ?? node.code}]`);
        id = node.parentId;
    }
    return parts.join(' / ');
}
export function validStructureParent(nodes, nodeId, parentId, byId = new Map(nodes.map(node => [node.id, node]))) {
    if (!parentId)
        return true;
    const seen = new Set();
    let next = parentId;
    while (next) {
        if (next === nodeId || seen.has(next))
            return false;
        seen.add(next);
        const parent = byId.get(next);
        if (!parent || parent.type === 'Premises' || ['Inactive', 'Archived'].includes(parent.status))
            return false;
        next = parent.parentId;
    }
    return true;
}
//# sourceMappingURL=building-structure.js.map